import { deleteRest, get, post, postWithoutBody, put } from 'utils/rxfetch'
import { buildURL } from 'utils/urls'

import { WHITELIST_TABLE_DEFAULT_PAGE_SIZE } from 'containers/Settings/Whitelist/constants'

const DMARC_REQUEST_INFO_ENDPOINT = '/members-api/settings/dmarc-request-info'

export default () => ({
  // Profile
  getProfileSettings() {
    return get('/members-api/settings/profile')
  },
  updateProfileSettings(settings) {
    return put('/members-api/settings/profile', settings)
  },
  updPassword(passwords) {
    return put('/members-api/account/password', passwords)
  },
  getPushNotificationSettings() {
    return get('/members-api/settings/push-notifications')
  },
  updatePushNotificationSettings(fields) {
    return put('/members-api/settings/push-notifications', fields)
  },
  // General
  getGeneralSettings(companyId = '') {
    return get(`/members-api/settings/general?companyFilter=${companyId}`)
  },
  updateGeneralSettings(companyId = '', settings) {
    return put(`/members-api/settings/general?companyFilter=${companyId}`, settings)
  },
  delCompanyLogo() {
    return deleteRest('/members-api/account/company-logo')
  },
  // Users
  getProfiles(companyId = '', filter = 'all') {
    return get(`/members-api/profiles/${filter}?companyFilter=${companyId}`)
  },
  getCompanyUsers(companyId = '', sortProperty, assignedCompanies) {
    return get(
      buildURL(
        '/members-api/account/users/',
        {
          companyFilter: companyId,
          sortProperty,
          assignedCompanies,
        },
        true
      )
    )
  },
  getManageableCompanies({ companyId, page, pageSize, search }) {
    return get(
      buildURL('/members-api/partner/manageable-companies', {
        companyFilter: companyId,
        page,
        pageSize,
        search,
      })
    )
  },
  getUserInfo(companyId, id) {
    return get(
      buildURL(`/members-api/account/users/${id}/`, {
        companyFilter: companyId,
      })
    )
  },
  delCompanyUser(companyId = '', userId) {
    return deleteRest(`/members-api/account/users/${userId}/?companyFilter=${companyId}`)
  },
  updCompanyUser(companyId = '', user) {
    return put(`/members-api/account/users/${user.id}/?companyFilter=${companyId}`, user)
  },
  addCompanyUser(companyId = '', user) {
    return post(`/members-api/account/users/?companyFilter=${companyId}`, user)
  },
  makeOwner(companyId = '', user) {
    return put(`/members-api/settings/makeowner?companyFilter=${companyId}`, user)
  },
  getManageableUserCompanies({
    id,
    companyId = '',
    page,
    pageSize,
    company,
    planTypes,
    mspRoleIds,
    isAssigned,
    allowedMspRoleId,
  }) {
    return get(
      buildURL(
        `/members-api/account/users/${id}/manageable-companies/`,
        {
          companyFilter: companyId,
          page,
          pageSize,
          company,
          planTypes,
          mspRoleIds,
          isAssigned,
          allowedMspRoleId,
        },
        true
      )
    )
  },
  assignCompanies({ id, companyId = '', data }) {
    return post(
      `/members-api/account/users/${id}/manageable-companies/?companyFilter=${companyId}`,
      data
    )
  },
  unassignMSPCompanies({ id, companyId = '', data }) {
    return deleteRest(
      `/members-api/account/users/${id}/manageable-companies/?companyFilter=${companyId}`,
      data,
      { 'Content-Type': 'application/json' }
    )
  },
  // Whitelist
  addWhitelist(companyId = '', item) {
    return postWithoutBody(`/members-api/settings/allowlist?companyFilter=${companyId}`, item)
  },

  editWhitelist(companyId = '', item) {
    return put(`/members-api/settings/allowlist?companyFilter=${companyId}`, item)
  },
  getWhitelisted(
    companyId = '',
    typeFilter = '',
    sortProperty = '',
    search = '',
    page = 1,
    itemsPerPage = WHITELIST_TABLE_DEFAULT_PAGE_SIZE
  ) {
    return get(
      `/members-api/settings/allowlist?companyFilter=${companyId}&typeFilter=${typeFilter}&sortProperty=${sortProperty}&search=${search}&page=${page}&itemsPerPage=${itemsPerPage}`
    )
  },
  deleteSelectedWhitelists(companyId = '', selectedIds) {
    return deleteRest(`/members-api/settings/allowlist?companyFilter=${companyId}`, { selectedIds })
  },
  // Languages
  getLanguages(companyId = '', associate = false) {
    return get(`/members-api/settings/languages?companyFilter=${companyId}&associate=${associate}`)
  },
  updateLanguages(companyId = '', body) {
    return put(`/members-api/settings/languages?companyFilter=${companyId}`, body)
  },
  // Partner
  getPartnerSettings() {
    return get('/members-api/settings/partner')
  },
  updatePartnerSettings(body) {
    return put('/members-api/settings/partner', body)
  },
  // Incident Response
  getIncidenceResponseSettings(companyId = '') {
    return get(`/members-api/settings/incident?companyFilter=${companyId}`)
  },
  updIncidenceResponseSettings(companyId = '', settings) {
    return put(`/members-api/settings/incident?companyFilter=${companyId}`, settings)
  },
  // IRONSCALES Community
  getFederationSettings(companyId = '') {
    return get(`/members-api/settings/federation?companyFilter=${companyId}`)
  },
  updFederationSettings(companyId = '', settings) {
    return put(`/members-api/settings/federation?companyFilter=${companyId}`, settings)
  },
  getSpamAllowList(companyId = '') {
    return get(`/members-api/spam-enabling/senders-counter?companyFilter=${companyId}`)
  },
  createSpamAllowList(emailsList, companyId = '') {
    return post(`/members-api/spam-enabling/bulk-create-whitelist?companyFilter=${companyId}`, {
      sender_emails: emailsList,
    })
  },
  toggleSpamFF(ffState, companyId = '') {
    return post(`/members-api/spam-enabling/toggle-ff?companyFilter=${companyId}`, {
      'ff-state': ffState,
    })
  },
  // Mailbox Protection
  getBanners(companyId = '') {
    return get(`/members-api/settings/ironsights?companyFilter=${companyId}`)
  },
  updBanners(companyId = '', values) {
    return put(`/members-api/settings/ironsights?companyFilter=${companyId}`, values)
  },
  getSightsLandingPages(companyId = '') {
    return get(`/members-api/ironsights/landings?companyFilter=${companyId}`)
  },
  updateSightsLandingPages(companyId = '', values) {
    return put(`/members-api/ironsights/landings?companyFilter=${companyId}`, values)
  },
  // Irontraps Customization
  getCustomizationSettings(companyId = '', shortName = 'En') {
    return get(`/members-api/settings/customization/${shortName}?companyFilter=${companyId}`)
  },
  updateCustomizationSettings(companyId = '', settings) {
    return put(`/members-api/settings/customization?companyFilter=${companyId}`, settings)
  },
  // Irontraps Customization O365
  getNotifications(companyId = '') {
    return get(`/owa/notifications/?companyFilter=${companyId}`)
  },
  updateNotifications(companyId = '', body) {
    return postWithoutBody(`/owa/notifications/?companyFilter=${companyId}`, body)
  },
  getReportingReasons(companyId = '') {
    return get(`/members-api/irontraps/reports/comment/options/?companyFilter=${companyId}`)
  },
  updateReportingReasons(companyId = '', body) {
    return put(`/members-api/irontraps/reports/comment/options/?companyFilter=${companyId}`, body)
  },
  restoreDefaultReasons(companyId = '') {
    return deleteRest(`/members-api/irontraps/reports/comment/options/?companyFilter=${companyId}`)
  },
  // Simulator
  getSimulatorSettings(companyId = '') {
    return get(`/members-api/settings/simulator?companyFilter=${companyId}`)
  },
  updateSimulatorSettings(companyId = '', settings) {
    return put(`/members-api/settings/simulator?companyFilter=${companyId}`, settings)
  },
  getCandidates(companyId = '', page, pageSize, search) {
    return get(
      buildURL(`/members-api/campaign-report-recipients/candidates/?companyFilter=${companyId}`, {
        page,
        pageSize,
        search,
      })
    )
  },
  getRecipients(companyId = '', page, pageSize) {
    return get(
      buildURL(`/members-api/campaign-report-recipients/?companyFilter=${companyId}`, {
        page,
        pageSize,
      })
    )
  },
  addRecipient(companyId = '', recipients, tags) {
    return post(`/members-api/campaign-report-recipients/?companyFilter=${companyId}`, {
      recipients,
      tags,
    })
  },
  removeRecipients(companyId = '', selectionData) {
    return deleteRest(
      `/members-api/campaign-report-recipients/delete-bulk/?companyFilter=${companyId}`,
      {
        selectionData,
      },
      { 'Content-Type': 'application/json' }
    )
  },
  // Email Server
  getEmailServerSettings(companyId = '') {
    return get(`/members-api/settings/emailserver?companyFilter=${companyId}`)
  },
  updEmailServerSettings(companyId = '', settings) {
    return put(`/members-api/settings/emailserver?companyFilter=${companyId}`, settings)
  },
  delExchangeCred(companyId = '') {
    return deleteRest(`/members-api/settings/emailserver?companyFilter=${companyId}`)
  },
  updMailboxInfo(companyId = '', mailbox) {
    return post(`/members-api/settings/emailserver?companyFilter=${companyId}`, {
      new_mailbox: mailbox,
    })
  },
  disable911Mailbox(companyId = '') {
    return put(`/members-api/settings/disable911?companyFilter=${companyId}`)
  },
  saveQuickIntegration(companyId = '', body) {
    return post(`/members-api/integrations/quick-deployment?companyFilter=${companyId}`, body)
  },
  getGsuiteStatus(companyId = '') {
    return get(`/members-api/integrations/gmail-webhooks?companyFilter=${companyId}`)
  },
  enableGsuiteIntegration(companyId = '') {
    return post(`/members-api/integrations/gmail-webhooks?companyFilter=${companyId}`)
  },
  disableGsuiteIntegration(companyId = '') {
    return deleteRest(`/members-api/integrations/gmail-webhooks?companyFilter=${companyId}`)
  },
  deleteGsuiteCredentials(companyId = '') {
    return deleteRest(
      `/members-api/integrations/gmail-webhooks/credentials?companyFilter=${companyId}`
    )
  },
  getO365Status(companyId = '') {
    return get(`/members-api/integrations/office365-webhooks?companyFilter=${companyId}`)
  },
  getPowershellStatus(companyId = '') {
    return get(
      `/members-api/office365/integrations/office365-powershell?companyFilter=${companyId}`
    )
  },
  disableO365Integration(companyId = '') {
    return deleteRest(`/members-api/integrations/office365-webhooks?companyFilter=${companyId}`)
  },
  disablePowershellIntegration(companyId = '') {
    return deleteRest(
      `/members-api/office365/integrations/office365-powershell?companyFilter=${companyId}`
    )
  },
  // Malware
  getMalwareDetection(companyId = '', name) {
    return get(`/members-api/integrations/${name}?companyFilter=${companyId}`)
  },
  updateMalwareDetection(companyId = '', name, body) {
    return post(`/members-api/integrations/${name}?companyFilter=${companyId}`, body)
  },
  deleteMalwareDetection(companyId = '', name) {
    return deleteRest(`/members-api/integrations/${name}?companyFilter=${companyId}`)
  },
  deleteIntegration(companyId = '', name) {
    return deleteRest(`/members-api/integrations/${name}?companyFilter=${companyId}`)
  },
  // getVxStreamsEnvs(companyId = '', api_key, secret_key, url) {
  //   return post(`/members-api/integrations/vxstream/envs?companyFilter=${companyId}`, { api_key, secret_key, url },)
  // },
  // Alerts
  getAlertsSettings(companyId = '') {
    return get(`/members-api/settings/alerts?companyFilter=${companyId}`)
  },
  updAlertsSettings(companyId = '', settings) {
    return put(`/members-api/settings/alerts?companyFilter=${companyId}`, settings)
  },
  removeCertificate(companyId = '') {
    return deleteRest(`/members-api/settings/alerts?companyFilter=${companyId}`)
  },
  // Email Notifications
  getAnnouncements(companyId = '', id) {
    return get(`/members-api/announcements/${parseInt(id)}?companyFilter=${companyId}`)
  },
  getAnnouncementLocale(companyId = '', activeId, localeId, announcementTrigger, isGroupSettings) {
    if (isGroupSettings) {
      return get(
        `/members-api/announcementlocale/group-settings-wizard/${activeId}/${localeId}/${announcementTrigger}?companyFilter=${companyId}`
      )
    } else {
      return get(
        `/members-api/announcementlocale/${activeId}/${localeId}/${announcementTrigger}?companyFilter=${companyId}`
      )
    }
  },
  updateAnnouncementLocale(companyId = '', data) {
    const tag = data.tag == 0 ? '' : data.tag
    return put(
      `/members-api/announcementlocale/${data.announcement_id}/${data.locale_id}/${data.trigger}?companyFilter=${companyId}`,
      {
        text: data.text,
        subject: data.subject,
        template: data.template,
        emailFrequency: data.emailFrequency,
        contactEmail: data.contactEmail,
        dateFilter: data.dateFilter,
        approachingLimitPercentage: data.approachingLimitPercentage,
        tag,
        includeSpam: data.includeSpam,
        askToRelease: data.askToRelease,
        participants: data.localRecipientsData.selected,
      }
    )
  },
  deleteAnnouncementLocale(companyId = '', data) {
    return deleteRest(
      `/members-api/announcementlocale/${data.announcement_id}/${data.locale_id}/${data.trigger}?companyFilter=${companyId}`,
      {}
    )
  },
  getAnnouncementsLogo(companyId = '') {
    return get(`/members-api/announcements/logo?companyFilter=${companyId}`)
  },
  updateAnnouncementsLogo(companyId = '', body) {
    return post(`/members-api/announcements/logo?companyFilter=${companyId}`, body)
  },
  fetchAnnouncementsParticipants(companyId = '', id, data) {
    return get(
      buildURL(`/members-api/announcements/participants/${parseInt(id)}`, {
        companyFilter: companyId,
        searchFilter: data.searchFilter,
      })
    )
  },
  getSystemNotificationsSettings(companyId = '') {
    return get(`/members-api/settings/system-notifications?companyFilter=${companyId}`)
  },
  updateSystemNotificationsSettings(companyId = '', settings) {
    return put(`/members-api/settings/system-notifications?companyFilter=${companyId}`, settings)
  },
  getCollaborationAppsData(companyId = '', integrationApp) {
    return get(
      `/members-api/integrations/collaboration-apps/${integrationApp}?companyFilter=${companyId}`
    )
  },
  updateCollaborationAppsData(companyId = '', integrationApp, body) {
    return post(
      `/members-api/integrations/collaboration-apps/${integrationApp}?companyFilter=${companyId}`,
      body
    )
  },
  updateCollaborationAppsAlerts(companyId = '', integrationApp, body) {
    return put(
      `/members-api/integrations/collaboration-apps/${integrationApp}?companyFilter=${companyId}`,
      body
    )
  },
  cancelCollaborationAppsIntegration(companyId = '', integrationApp) {
    return deleteRest(
      `/members-api/integrations/collaboration-apps/${integrationApp}?companyFilter=${companyId}`
    )
  },
  // Disclaimers
  getDisclaimers() {
    return get('/members-api/settings/disclaimers')
  },
  addDisclaimer(disclaimer) {
    return post('/members-api/settings/disclaimers', disclaimer)
  },
  updateDisclaimer(disclaimer) {
    return put('/members-api/settings/disclaimers', disclaimer)
  },
  verifyDomain(mailerDomain, companyFilter) {
    return post(
      `/members-api/settings/verify-mailer-domain?${
        companyFilter ? `companyFilter=${companyFilter}` : ''
      }`,
      { mailerDomain }
    )
  },
  getCncAccess(companyFilter) {
    return get(
      `/members-api/account/cnc-access?${companyFilter ? `companyFilter=${companyFilter}` : ''}`
    )
  },
  setCncAccess(cncAccess, companyFilter) {
    return put(
      `/members-api/account/cnc-access?${companyFilter ? `companyFilter=${companyFilter}` : ''}`,
      { cncAccess }
    )
  },
  // Group Settings
  getGroupSettingsName(companyFilter) {
    return get(`/members-api/settings/group-settings-name?companyFilter=${companyFilter}`)
  },
  getMicrosoftQuarantine(companyFilter = '') {
    return get(`/members-api/settings/microsoft?companyFilter=${companyFilter}`)
  },
  updateMicrosoftQuarantine(companyFilter = '', microsoftDetectionsEnabled, powershellEnabled) {
    return put(`/members-api/settings/microsoft?companyFilter=${companyFilter}`, {
      microsoftDetectionsEnabled,
      microsoftReleaseQuarantinedEmailEnabled: powershellEnabled,
    })
  },
  releaseMSQuarantineEmail(messageId, newEid, recipientAddress, index) {
    return post('/members-api/search/investigation/release_email', {
      message_id: messageId,
      new_eid: newEid,
      recipient_address: recipientAddress,
      index,
    })
  },
  releaseMSQuarantineEmailStatus(taskId) {
    return get(
      buildURL('/members-api/search/investigation/release_email', {
        task_id: taskId,
      })
    )
  },
  // DeepFake
  getDeepfakeConfig() {
    return get('/members-api/deepfake/company/')
  },
  updateDeepfakeConfig(body) {
    return put('/members-api/deepfake/company/', body)
  },
  getDeepfakeKeyMembers() {
    return get('/members-api/deepfake/company/key_members/')
  },
  createDeepfakeKeyMember(body) {
    return post('/members-api/deepfake/company/key_members/', body)
  },
  updateDeepfakeKeyMember(id, body) {
    return put(`/members-api/deepfake/company/key_members/${id}/`, body)
  },
  deleteDeepfakeKeyMember(id) {
    return deleteRest(`/members-api/deepfake/company/key_members/${id}/`)
  },
  getWarningReportRecipients() {
    return get('/members-api/deepfake/warning_report_recipients/')
  },
  getWarningReportCandidates() {
    return get('/members-api/deepfake/warning_report_candidates/')
  },
  addWarningReportRecipients(body) {
    return post('/members-api/deepfake/warning_report_recipients/batch-add/', body)
  },
  deleteWarningReportRecipients(body) {
    return post('/members-api/deepfake/warning_report_recipients/batch-delete/', body)
  },
  getDeepFakeAllowList() {
    return get('/members-api/deepfake/company/whitelist/')
  },
  addDeepFakeAllowList(body) {
    return post('/members-api/deepfake/company/whitelist/', body)
  },
  deleteDeepFakeAllowList(id) {
    return deleteRest(`/members-api/deepfake/company/whitelist/${id}/`)
  },

  // Dmarc request info
  getDmarcRequestInfo() {
    return get(DMARC_REQUEST_INFO_ENDPOINT)
  },
  postDmarcRequestInfo(body) {
    return post(DMARC_REQUEST_INFO_ENDPOINT, body)
  },
})
